/* sf-extras
 * Manda al carrito los extras encendidos junto con el kit.
 *
 * Por que un oyente en `document` y en fase de captura:
 *   product-form.js escucha `submit` en el propio formulario y ahi mismo hace
 *   preventDefault y su propio fetch. Un oyente registrado en el MISMO elemento
 *   correria despues, cuando ya no hay nada que hacer. Un oyente en un ancestro y en
 *   captura corre antes, siempre, sin tocar product-form.js.
 *
 * Orden: primero los extras, despues el kit. Asi la respuesta del kit ya trae el carrito
 * completo y el cajon se dibuja una sola vez, con todo adentro.
 *
 * Si el alta de un extra falla, el kit entra igual. Que un accesorio de bajo valor rompa
 * la compra del kit seria el peor final posible.
 */
(function () {
  'use strict';

  var ENVIANDO = 'sfExtrasEnviando';

  /* OJO: el bloque de extras NO esta adentro del <form>.
   * En Spotlight el formulario vive adentro del bloque buy_buttons, asi que cualquier
   * bloque puesto mas arriba en la ficha queda fuera de el. Buscar con
   * form.querySelector() no encuentra nada y los extras nunca llegarian al carrito.
   * Por eso se busca en la seccion que contiene al formulario. */
  function contenedor(form) {
    return form.closest('.shopify-section') || form.closest('product-info') || document;
  }

  function elegidos(form) {
    var caja = contenedor(form).querySelector('[data-sf-extras]');
    if (!caja) return [];
    var out = [];
    caja.querySelectorAll('.sf-extra__sw').forEach(function (sw) {
      if (!sw.checked || sw.disabled) return;
      var id = sw.getAttribute('data-variant-id');
      if (id) out.push({ id: Number(id), quantity: 1 });
    });
    return out;
  }

  /* Si el alta del extra falla, el kit sigue de largo (eso ya estaba), pero el comprador
   * tiene que enterarse. Antes fallaba en silencio: pagaba el kit creyendo que le llevaba
   * la espatula y se enteraba al abrir el paquete. */
  function avisarFallo(caja) {
    if (!caja) return;
    var aviso = caja.querySelector('[data-sf-extras-aviso]');
    if (!aviso) {
      aviso = document.createElement('p');
      aviso.setAttribute('data-sf-extras-aviso', '');
      aviso.setAttribute('role', 'alert');
      aviso.style.cssText = 'margin:.6rem 0 0;font-size:.85em;color:#c22;';
      caja.appendChild(aviso);
    }
    aviso.textContent =
      'No pudimos agregar los adicionales. El kit se agrega igual; probá sumarlos de nuevo.';
  }

  function limpiarAviso(caja) {
    var aviso = caja && caja.querySelector('[data-sf-extras-aviso]');
    if (aviso) aviso.remove();
  }

  function agregar(items) {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    });
  }

  /* --- Punto 6, cliente 2026-09-16: "poder hacer clic en la imagen para agrandarla porque no
   * se ve que es lo que le estan sumando adicional".
   *
   * Toda la fila del extra es un <label>, o sea que cualquier clic adentro prende el
   * interruptor. Por eso este oyente va en CAPTURA y en `document`: corre antes de que el
   * navegador active el label, y ahi se corta. Sin esto, mirar la foto sumaria el extra al
   * pedido sin que el comprador lo haya pedido.
   *
   * El visor se agrega al final del <body>, fuera del label, por el mismo motivo.
   * Sin JS el boton no hace nada y el clic sigue prendiendo el extra: se pierde el zoom, no
   * la compra. --- */
  var visor = null;

  function cerrarVisor() {
    if (!visor) return;
    visor.remove();
    visor = null;
    document.removeEventListener('keydown', alEscape);
  }

  function alEscape(ev) {
    if (ev.key === 'Escape') cerrarVisor();
  }

  /* Cliente 2026-09-17: la ventana deja de ser solo la foto en grande. Ahora lleva todas las
   * fotos del producto y su descripcion, para que pueda leer para que sirve la herramienta sin
   * salir de la ficha de compra.
   *
   * Los datos vienen del <script class="sf-extra__datos"> que deja el Liquid al lado del boton,
   * asi que no hay ninguna consulta al servidor: ya estaban en la pagina.
   * Si ese JSON faltara o estuviera roto, se cae a la foto sola, que es lo que habia antes. */
  function pintarCierre(caja) {
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'sf-extra-zoom__x';
    x.setAttribute('aria-label', 'Cerrar');
    x.textContent = '\u00d7';
    caja.appendChild(x);
  }

  function datosDe(boton) {
    var fila = boton.closest('.sf-extra');
    var tag = fila && fila.querySelector('.sf-extra__datos');
    if (!tag) return null;
    try {
      var d = JSON.parse(tag.textContent);
      return d && d.fotos && d.fotos.length ? d : null;
    } catch (e) {
      return null;
    }
  }

  function abrirVisor(src, nombre, datos) {
    cerrarVisor();
    visor = document.createElement('div');
    visor.className = 'sf-extra-zoom' + (datos ? ' es-ficha' : '');
    visor.setAttribute('role', 'dialog');
    visor.setAttribute('aria-modal', 'true');
    visor.setAttribute('aria-label', nombre || 'Foto del adicional');

    if (datos) {
      var caja = document.createElement('div');
      caja.className = 'sf-extra-zoom__caja';
      // Un clic adentro de la caja NO cierra; si no, tocar una miniatura cerraria la ventana.
      caja.addEventListener('click', function (e) { e.stopPropagation(); });

      var grande = document.createElement('img');
      grande.className = 'sf-extra-zoom__grande';
      grande.src = datos.fotos[0].g;
      grande.alt = datos.nombre || nombre || '';
      caja.appendChild(grande);

      if (datos.fotos.length > 1) {
        var tira = document.createElement('div');
        tira.className = 'sf-extra-zoom__tira';
        datos.fotos.forEach(function (f, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'sf-extra-zoom__mini' + (i === 0 ? ' es-activa' : '');
          b.setAttribute('aria-label', 'Foto ' + (i + 1));
          var mi = document.createElement('img');
          mi.src = f.ch;
          mi.alt = '';
          b.appendChild(mi);
          b.addEventListener('click', function () {
            grande.src = f.g;
            tira.querySelectorAll('.sf-extra-zoom__mini').forEach(function (o) { o.classList.remove('es-activa'); });
            b.classList.add('es-activa');
          });
          tira.appendChild(b);
        });
        caja.appendChild(tira);
      }

      var tit = document.createElement('h3');
      tit.className = 'sf-extra-zoom__titulo';
      tit.textContent = datos.nombre || nombre || '';
      caja.appendChild(tit);

      if (datos.desc) {
        // Cliente 2026-09-30: respetar negrita y renglones. datos.desc es el HTML del editor de
        // Shopify (contenido propio del cliente). Se pinta con innerHTML + clase `rte` para que
        // tome el estilo de texto enriquecido del tema; el CSS acota fotos/tablas. Es un <div>
        // porque el HTML trae <p>/<ul> que no pueden ir dentro de un <p>.
        var txt = document.createElement('div');
        txt.className = 'sf-extra-zoom__desc rte';
        txt.innerHTML = datos.desc;
        caja.appendChild(txt);
      }

      visor.appendChild(caja);
      pintarCierre(visor);
      visor.addEventListener('click', cerrarVisor);
      document.addEventListener('keydown', alEscape);
      document.body.appendChild(visor);
      visor.querySelector('.sf-extra-zoom__x').focus();
      return;
    }

    var img = document.createElement('img');
    img.src = src;
    img.alt = nombre || '';
    visor.appendChild(img);

    pintarCierre(visor);

    // Un clic en cualquier lado cierra, igual que en la galeria de colores.
    visor.addEventListener('click', cerrarVisor);
    document.addEventListener('keydown', alEscape);
    document.body.appendChild(visor);
    x.focus();
  }

  document.addEventListener(
    'click',
    function (ev) {
      var t = ev.target;
      var boton = t && t.closest ? t.closest('[data-sf-extra-zoom]') : null;
      if (!boton) return;
      // Cortar ANTES de que el label haga lo suyo.
      ev.preventDefault();
      ev.stopPropagation();
      var src = boton.getAttribute('data-sf-extra-zoom');
      if (src) abrirVisor(src, boton.getAttribute('data-sf-extra-nombre'), datosDe(boton));
    },
    true // captura
  );

  document.addEventListener(
    'submit',
    function (ev) {
      var form = ev.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

      // Segunda vuelta: dejamos pasar para que product-form haga lo suyo.
      if (form.dataset[ENVIANDO] === '1') {
        delete form.dataset[ENVIANDO];
        return;
      }

      var items = elegidos(form);
      if (!items.length) return; // sin extras no nos metemos en el camino

      ev.preventDefault();
      ev.stopPropagation();

      var boton = form.querySelector('[type="submit"]');
      var caja = contenedor(form).querySelector('[data-sf-extras]');
      limpiarAviso(caja);

      agregar(items)
        .then(function (res) {
          // Un 4xx tambien es un fallo aunque la promesa se resuelva: sin stock, por ejemplo.
          if (res && res.ok === false) throw new Error('HTTP ' + res.status);
        })
        .catch(function (e) {
          console.error('sf-extras: no se pudo agregar un extra', e);
          avisarFallo(caja);
        })
        .then(function () {
          form.dataset[ENVIANDO] = '1';
          // requestSubmit vuelve a disparar `submit`, y esta vez pasa de largo hasta
          // product-form.js, que agrega el kit y dibuja el carrito ya completo.
          if (form.requestSubmit) form.requestSubmit(boton || undefined);
          else form.submit();
        });
    },
    true // captura
  );
})();
